import Vue from 'vue';
import RestController from './RestController';
import BeatLoader from 'vue-spinner/src/BeatLoader';
import berlinPostalcodes from './BerlinPostalcodes';

window.addEventListener("load", function(event) {
    let elements = document.getElementsByClassName('partner-form');

    for (let el of elements) {
        new Vue({
            el: el,
            components: {
                BeatLoader,
            },
            data: () => {
                return {
                    brands: [],
                    models: [],
                    built_dates: [],
                    submodels: [],
                    types: [],
                    constructions: [],
                    partner: '',

                    brand: false,
                    brandName: false,
                    model: false,
                    built_date: false,
                    submodel: false,
                    type: false,
                    construction: false,

                    month: -1,
                    year: null,
                    mileage: null,

                    berlinPostalcodes: berlinPostalcodes,

                    hsn: '',
                    tsn: '',
                    postalcode: '',
                    rest: null,
                    spinner_color: '#2588d9'
                };
            },
            methods: {
                getPartnerSlug: function () {
                    this.partner = this.$refs.partner.value;
                },
                getBrands: async function () {
                    this.brands = await this.rest.brands();
                },
                reset: async function (level) {
                    if (level <= 1) {
                        this.models = [];
                        this.model = false;
                    }
                    if (level <= 2) {
                        this.built_dates = [];
                        this.built_date = false;
                    }
                    if (level <= 3) {
                        this.constructions = [];
                        this.construction = false;
                    }
                    if (level <= 4) {
                        this.submodels = [];
                        this.submodel = false;
                    }
                    if (level <= 5) {
                        this.types = [];
                        this.type = false;
                    }
                },
                compare: function ( a, b ) {
                    if ( a.name < b.name ) {
                        return -1;
                    }
                    if ( a.name > b.name ) {
                        return 1;
                    }
                    return 0;
                }
            },
            mounted() {
                this.getPartnerSlug();
                this.rest = new RestController(partners.resturl, this.partner);
                if (typeof this.$refs.form.dataset.brandName !== 'undefined') {
                    this.brandName = this.$refs.form.dataset.brandName;
                }
                this.getBrands();
            },
            watch: {
                brands: async function (brands) {
                    let vm = this;

                    if (this.brandName) {
                        brands.forEach(function (brand) {
                            if (brand.name.toUpperCase() === vm.brandName.toUpperCase()) {
                                vm.brand = brand.unique_vid;
                            }
                        })
                    }
                },
                brand: async function (value, oldValue) {
                    this.reset(1);
                    this.models = await this.rest.models(this.brand, this.month, this.year);

                    if (this.$refs.form.dataset.model !== undefined && this.$refs.form.dataset.model !== this.model) {
                        this.model = this.$refs.form.dataset.model
                    }
                    if (oldValue !== value && oldValue !== false) {
                        this.model = false
                    }
                },
                model: async function (value) {
                    this.reset(2);
                    this.built_dates = await this.rest.built_dates(this.brand, this.model);
                },
                built_date: async function (value) {
                    this.reset(3);
                    this.constructions = await this.rest.constructions(this.brand, this.model, this.built_date);
                },
                construction: async function (value) {
                    this.reset(4);
                    this.submodels = await this.rest.submodels(this.brand, this.model, this.built_date, this.construction);
                },
                submodel: async function (value) {
                    this.reset(5);
                    if (typeof this.brand === "undefined" || typeof this.model === "undefined" ) {
                        return
                    }
                    this.types = await this.rest.types(this.brand, this.model, this.built_date, this.construction, this.submodel);
                },
            },
            computed: {
                importantBrands: function () {
                    return this.brands.filter(function (u) {
                        return u.important;
                    })
                },
                allBrands: function () {
                    return this.brands.filter(function (u) {
                        return !u.important;
                    })
                },
                allModels: function () {
                    return this.models.sort(this.compare)
                }
            }
        });
    }
});